import React, { FC } from 'react';
import { useEffect, useState } from 'react';
import { eventDayDifference } from '../../utils/eventDataFormat';
import { Typography } from '@getgo/chameleon-web/react';
import { IEventDetail } from '../eventInterface';
import { IUserDetail } from '../../context/userContext';
import AddEventButton from '../../addEvent/AddEventButton';
import { useEventContext } from '../../context/eventContext';
import { useTranslation } from 'react-i18next';
import { dateFormatted, welcomeMessage } from '../../../strings/event.strings';

export interface EventRegisteredUserProps {
  eventDetail: IEventDetail;
  userDetail: IUserDetail;
}

const EventRegisteredUser: FC<EventRegisteredUserProps> = ({ userDetail, eventDetail }) => {
  const { t } = useTranslation();
  const event = useEventContext();
  const eventStartDate = new Date(eventDetail.start);
  const eventEndDate = new Date(eventDetail.end);
  let diffFrom: Date | null;
  if (new Date() < eventStartDate) {
    diffFrom = eventStartDate;
  } else if (new Date() > eventStartDate && new Date() < eventEndDate) {
    diffFrom = eventEndDate;
  } else {
    diffFrom = null;
  }

  const [diffDate, setDiffDate] = useState(diffFrom ? eventDayDifference(diffFrom) : diffFrom);

  useEffect(() => {
    if (diffFrom) {
      const interval = setInterval(() => {
        setDiffDate(eventDayDifference(diffFrom));
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [diffDate, diffFrom]);
  return (
    <div className="event-registered-user">
      <div>
        <Typography color="text-01" variant="heading-small" tag="h3">
          {welcomeMessage(userDetail.firstName, userDetail.lastName)}
        </Typography>
      </div>
      <div className="event-registered-user-small-box">
        <Typography color="text-01" variant="body-small">
          {new Date() < eventStartDate
            ? t('event.registration.descriptionBeforeEvent')
            : new Date() > eventStartDate && new Date() < eventEndDate
            ? t('event.registration.descriptionDuringEvent')
            : t('event.registration.descriptionAfterEvent')}
        </Typography>
      </div>
      {diffFrom !== null && (
        <>
          <div className="event-registered-user-small-box-title">
            <Typography variant="body-small" color="text-01">
              {diffFrom === eventStartDate
                ? t('event.registration.kickThingsTxt')
                : t('event.registration.timeLeftTxt')}
            </Typography>
          </div>
          <Typography variant="body-small" color="text-01">
            <div className="event-registered-user-small-box">
              {dateFormatted(diffDate.days, diffDate.hours, diffDate.minutes)}
            </div>
          </Typography>
        </>
      )}
      {new Date() > eventEndDate ? null : (
        <div className="event-registered-user-calendar">
          <AddEventButton
            buttonName={t('event.registration.addEventToCalendar')}
            eventKey={event?.eventDetails?.eventKey}
            title={eventDetail.title}
            eventEndDate={eventEndDate}
            eventStartDate={eventStartDate}
            timezone={Intl.DateTimeFormat().resolvedOptions().timeZone}
            withDropdown
          />
        </div>
      )}
    </div>
  );
};

export default EventRegisteredUser;
